import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'
import ReportsIndex from '@/components/reports/reports-index.vue'
import CertificatesIndex from "@/components/certificates/certificates-index.vue";
import CreateCertificateIndex from "@/components/create-certificate/index/create-certificate-index.vue";
import RegistrationsIndex from "@/components/registrations/registrations-index.vue"
import CreateRegistrationsIndex from "@/components/registrations/create-registration/index/create-registration-index.vue"
import LoginPageVue from '@/components/login/Login-page.vue';
import * as constants from "@/config/constants";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: ReportsIndex,
    meta: {
      requireAuth: true,
      requireRoles: constants.DASHBOARD_ROLES,
      menuIcon: "fal fa-objects-column",
    }
  },
  {
    path: '/certificates',
    name: 'Certificates',
    component: CertificatesIndex,
    meta: {
      requireAuth: true,
      requireRoles: constants.LIST_CERTIFICATE_ROLES,
      menuIcon: "fal fa-file-certificate",
    },
  },
  {
    path: '/certificates/submit-certificate-request',
    name: 'Submit certificate request',
    component: CreateCertificateIndex,
    meta: {
      requireAuth: true,
      requireRoles: constants.CREATE_CERTIFICATE_ROLES
    }
  },
  {
    path: '/registrations',
    name: 'Registrations',
    component: RegistrationsIndex,
    meta: {
      requireAuth: true,
      requireRoles: constants.LIST_REGISTRATION_ROLES,
      menuIcon: "fal fa-pen-field",
    },
  },
  {
    path: '/registrations/create-registration',
    name: 'Create registration',
    component: CreateRegistrationsIndex,
    meta: {
      requireAuth: true,
      requireRoles: constants.CREATE_REGISTRATION_ROLES
    }
  },
  {
    path: constants.LOGIN_ROUTE_PATH,
    name: 'Login page',
    component: LoginPageVue,
    meta: {
      hideFooter: true,
      hideNavigation: true
    }
  },
  {
    path: constants.LOGOUT_ROUTE_PATH,
    name: 'Logout page',
    component: LoginPageVue,
    meta: {
      hideFooter: true,
      hideNavigation: true
    }
  },
  { path: '*', redirect: '/' }
];


const router = new VueRouter({
  routes,
  base: constants.WEB_UI_ROOT,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  store.dispatch("checkAuthStatus").then(() => {
    if (to.meta?.requireAuth && !store.getters.getIsAuthenticated) {
      next({ path: constants.LOGIN_ROUTE_PATH });
    } else if (to.meta?.requireRoles && !to.meta?.requireRoles.every((role) => store.getters.getRoles.includes(role))) {
      let path = to.path === "/" ? constants.LOGIN_ROUTE_PATH : "/";
      next({ path: path });
    } else {
      next();
    }
  });
});

export default router;
